import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser, PopupModal } from "../Components";
import Masters from "../Components/masters.json";
import axiosConfig from "../Service/axiosConfig";
import { NavLink } from "react-router-dom";

const AddStore = () => {
    const MastersModal = Masters.AddStore
    const [popupType, setpopupType] = useState("")
    const [Error, SetError] = useState("")
    const [message, setMessage] = useState("")
    const formSubmit = (Data) => {
        const coordsArray =
          Data.polygon && Data.polygon.length >= 3
            ? Data.polygon
            : Data.polygon_coordinates && Data.polygon_coordinates.length >= 3
            ? Data.polygon_coordinates
            : [];

        if (coordsArray.length < 3) {
          SetError("Please draw a delivery polygon boundary on the map (minimum 3 points required).");
          setpopupType("error");
          return;
        }

        const data_to_post = {
          ...Data,
          logo_image: typeof Data.logo_image === "object" ? Data.logo_image?.id : Data.logo_image,
          banner_image: typeof Data.banner_image === "object" ? Data.banner_image?.id : Data.banner_image,
          boundary_type: "polygon",

          polygon_coordinates: coordsArray.map((point) => {
            if (Array.isArray(point)) {
              return {
                lat: Number(point[0]),
                lng: Number(point[1]),
              };
            }
            return {
              lat: Number(point?.lat !== undefined ? point.lat : point?.[0] || 0),
              lng: Number(point?.lng !== undefined ? point.lng : point?.[1] || 0),
            };
          }),
          spike_percentage:
            parseFloat(Data.spike_percentage) > 0
              ? parseFloat(Data.spike_percentage)
              : 0.0,
          slot_duration:
            Data.slot_duration !== undefined && Data.slot_duration !== ""
              ? Number(Data.slot_duration)
              : 0,
        };

        if (Data.express_delivery !== undefined) {
          data_to_post.express_delivery =
            Data.express_delivery === true || Data.express_delivery === "true" ? "true" : "false";
        }
        if (Data.schedule_delivery !== undefined) {
          data_to_post.schedule_delivery =
            Data.schedule_delivery === true || Data.schedule_delivery === "true" ? "true" : "false";
        }
        if (Data.latitude !== undefined && Data.latitude !== "") {
          data_to_post.latitude = Number(Data.latitude);
        }
        if (Data.longitude !== undefined && Data.longitude !== "") {
          data_to_post.longitude = Number(Data.longitude);
        }

        if (data_to_post.express_delivery !== "true" && data_to_post.schedule_delivery !== "true") {
          SetError("Please check The delivery option.");
          setpopupType("error");
          return;
        } else if (data_to_post.schedule_delivery === "true" && !data_to_post.slot_duration) {
          SetError("Please mention slot duration");
          setpopupType("error");
          return;
        }

        if (data_to_post.mobileno && data_to_post.mobileno.length < 10) {
          SetError("Please enter valid mobile number");
          setpopupType("error");
          return;
        }

        if (!data_to_post.latitude || !data_to_post.longitude) {
          SetError("Please select location from map to get latitude and longitude");
          setpopupType("error");
          return;
        }

        const latitude = parseFloat(data_to_post.latitude);
        const longitude = parseFloat(data_to_post.longitude);

        if (isNaN(latitude) || isNaN(longitude)) {
          SetError(
            "Please enter valid latitude and longitude or select location from map to get latitude and longitude"
          );
          setpopupType("error");
          return;
        }

        const hasFiles = Object.values(data_to_post).some(
          (val) => val instanceof File || val instanceof Blob
        );
        if (hasFiles) {
          axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
        } else {
          axiosConfig.defaults.headers["Content-Type"] = "application/json";
        }

        axiosConfig.post(`/stores/stores/`, data_to_post).then(res => {
            console.log(res)
            setMessage(res.data?.message || "Store added successfully")
            setpopupType("success")
            SetError("")
        }).catch(error => {
            console.log(error)
            SetError(error.response?.data?.detail || "Error adding store")
            setpopupType("error")
        })
    }

    useEffect(() => {
    }, [])
    return (
        <>
            <div className="dashboard-header">
                <h5 className="dashboard-subtitle">Add Store</h5>
            </div>
            <FormParser modelObject={MastersModal} formSubmit={formSubmit} error={Error} />
            {popupType != "" &&
                <PopupModal popupType={popupType} Navigation="/dashboard/admin/profile" Message={message} setMessage={setMessage} error={Error} setpopupType={setpopupType} />
            }
        </>
    )
}

export { AddStore }